export const QUERY_PROMOCODE_PARAM_NAME = 'promocode';
